<template>
  <nav-submenu v-if="showConferencesNav" label="Conferences">
    <b-dropdown-item to="/conferences/all">All Conferences</b-dropdown-item>
    <b-dropdown-item
      to="/approvals"
      v-if="isAuthenticated && userIsApproved && hasApprovals && conferencesEnabled"
    >
      My Approvals
    </b-dropdown-item>
    <b-dropdown-item
      v-if="isAuthenticated && userIsApproved && conferencesEnabled"
      to="/conferences"
    >
      My Applications
    </b-dropdown-item>
    <b-dropdown-item href="https://ifac.floq.live/" target="_blank">
      Go to Conference App
    </b-dropdown-item>
  </nav-submenu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import NavSubmenu from '@/views/components/nav/NavSubmenu.vue';

export default {
  name: 'ConferencesNavItem',
  components: { NavSubmenu },
  created() {
    if (this.isAuthenticated) {
      this.fetchSettings();
      this.fetchApprovals({
        page: 1,
        perPage: 1,
      });
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      hasApprovals: 'approvals/hasApprovals',
      isAuthenticated: 'auth/isAuthenticated',
      conferencesEnabled: 'settings/conferencesEnabled',
    }),
    userIsApproved() {
      return this.user?.isApproved;
    },
    showConferencesNav() {
      if (!this.isAuthenticated) {
        return true;
      }

      return this.conferencesEnabled;
    },
  },
  methods: {
    ...mapActions({
      fetchSettings: 'settings/fetchSettings',
      fetchApprovals: 'approvals/fetchApprovals',
    }),
  },
};
</script>
